import React, {Component} from 'react';

import FreeDownloads from './free-downloads';

export default class DownloadsColumn extends Component {
	render() {
		return (
			<div className="downloads-col col-xs-12 col-sm-6 col-md-4">
				<FreeDownloads downloads={ this.props.downloads } bookLink={ this.props.bookLink } />
			</div>
		);
	}
}